import { useState } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import AddIcon from "@mui/icons-material/AddOutlined";
import { DataTable, type Column } from "@/components/data/data-table";
import { EmptyState } from "@/components/feedback/states";
import { RegisterSchemaDialog } from "@/components/catalog/register-schema-dialog";
import { useSchemaSubjects } from "@/api/catalog";

export const Route = createFileRoute("/_app/catalog/schemas/")({
  component: SchemaSubjects,
});

function SchemaSubjects() {
  const navigate = useNavigate();
  const { data, isLoading, error, refetch } = useSchemaSubjects();
  const [registering, setRegistering] = useState(false);

  const columns: Column<string>[] = [
    { id: "subject", header: "Subject", cell: (s) => s, sortValue: (s) => s },
  ];

  return (
    <Card>
      <DataTable
        columns={columns}
        data={data}
        isLoading={isLoading}
        error={error}
        onRetry={() => refetch()}
        rowKey={(s) => s}
        search={(s) => s}
        searchPlaceholder="Search subjects…"
        toolbar={
          <Button
            size="small"
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setRegistering(true)}
          >
            Register schema
          </Button>
        }
        onRowClick={(s) => navigate({ to: "/catalog/schemas/$subject", params: { subject: s } })}
        empty={
          <EmptyState
            title="No schemas registered"
            description="Register Avro / JSON / Protobuf schemas for your ingest endpoints and topics."
          />
        }
      />
      <RegisterSchemaDialog
        open={registering}
        onClose={() => setRegistering(false)}
        onRegistered={(s) => navigate({ to: "/catalog/schemas/$subject", params: { subject: s } })}
      />
    </Card>
  );
}
